<template>
  <app-icon
    name="ChevronRightIcon"
    :class="[
      'h-5 w-5 text-gray-500 transition transform',
      rotate ? '-rotate-90' : 'rotate-90',
    ]"
  />
</template>
<script>
export default {
  props: {
    rotate: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
